import { defineMessages } from 'react-intl';

const scope = 'app.workspace.cohorts.grades.review';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Manual Grade Review',
  },
  breadcrumbsTitle: {
    id: `${scope}.breadcrumbstitle`,
    defaultMessage: 'Manual Grading',
  },
  description: {
    id: `${scope}.title`,
    defaultMessage: 'Manual Grade Review',
  },
  noAttempt: {
    id: `${scope}.noAttempt`,
    defaultMessage: 'The student has not attempted this screen',
  },
});
